import React from "react";
import cn from "classnames";
import closeGrayIcon from "@src/assets/svg/close-icon-gray.svg";
import thingsSupportIcon from "@src/assets/svg/things-support-blue.svg";
import lockClosedIcon from "@src/assets/svg/lock-closed-gray.svg";
import { HelpIconPopover } from "@src/components/atoms/help-icon-popover/help-icon-popover";
import { useAddNewMachineDrawerModalContext } from "./add-new-machine-drawer-modal-context";
import styles from "./add-new-machine-drawer-modal.module.scss";

const cssClassName = "add-new-machine-drawer-modal";

export const VncSkillCard = () => {
  const {
    texts,
    machineSkillsTexts,
    isSupportExpanded,
    isVncInstalled,
    vncPort,
    showVncPortAvailable,
    setIsSupportExpanded,
    setVncPort,
  } = useAddNewMachineDrawerModalContext();

  return (
    <div
      className={cn(styles["skill-card"], {
        [styles["skill-card-installed"]]: isVncInstalled,
      })}
      title={
        isVncInstalled
          ? machineSkillsTexts.installedSkillTooltip.replace("{skill}", "VNC")
          : undefined
      }
      aria-disabled={isVncInstalled}
    >
      <div className={styles["skill-card-header"]}>
        <div className={styles["skill-card-header-left"]}>
          <img
            src={thingsSupportIcon}
            alt={machineSkillsTexts.thingsSupportTitle}
            className={styles["skill-card-icon"]}
          />
          <h4 className={styles["skill-card-title"]}>
            {machineSkillsTexts.thingsSupportTitle}
          </h4>
          {isVncInstalled && (
            <span
              className={styles["skill-installed-badge"]}
              title={machineSkillsTexts.installedSkillTooltip.replace(
                "{skill}",
                "VNC",
              )}
            >
              <img src={lockClosedIcon} alt="" />
              {machineSkillsTexts.installedSkillLabel}
            </span>
          )}
        </div>
        <button
          type="button"
          className={styles["toggle-skill-button"]}
          disabled={isVncInstalled}
          onClick={() => setIsSupportExpanded(!isSupportExpanded)}
        >
          <span className={styles["toggle-skill-button-symbol"]}>
            {isSupportExpanded ? "−" : "+"}
          </span>
        </button>
      </div>
      <div className={styles["skill-card-content"]}>
        <p className={styles["skill-card-description"]}>
          {machineSkillsTexts.thingsSupportDescription}
        </p>
      </div>

      {isSupportExpanded && (
        <fieldset
          className={cn(
            styles["skill-card-expanded-content"],
            styles["skill-card-fieldset"],
          )}
          disabled={isVncInstalled}
        >
          <div className={styles[`${cssClassName}__input-container`]}>
            <div className={styles["skill-label-row"]}>
              <label className={styles[`${cssClassName}__label`]}>
                {machineSkillsTexts.vncPortLabel}
              </label>
              <span className={styles["skill-help-container"]}>
                <HelpIconPopover
                  helpLabel={texts.help}
                  helpText={machineSkillsTexts.vncPortHelpText}
                />
              </span>
            </div>
            <div className={styles[`${cssClassName}__input-wrapper`]}>
              <input
                type="text"
                placeholder={machineSkillsTexts.vncPortPlaceholder}
                value={vncPort}
                className={styles[`${cssClassName}__input`]}
                onChange={(e) => setVncPort(e.target.value)}
              />
              {vncPort && !isVncInstalled && (
                <button
                  type="button"
                  className={styles["port-clear-button"]}
                  onClick={() => setVncPort("")}
                >
                  <img src={closeGrayIcon} alt="" />
                </button>
              )}
            </div>
            {showVncPortAvailable && (
              <p className={styles["port-available-text"]}>
                {machineSkillsTexts.portIsAvailableLabel}
              </p>
            )}
          </div>
        </fieldset>
      )}
    </div>
  );
};
